module.exports = __webpack_public_path__ + "img/39000.d2402a1d.jpg";